import { render, staticRenderFns } from "./deadwipcost.vue?vue&type=template&id=443cb126&scoped=true&"
import script from "./deadwipcost.vue?vue&type=script&lang=js&"
export * from "./deadwipcost.vue?vue&type=script&lang=js&"
import style0 from "./deadwipcost.vue?vue&type=style&index=0&id=443cb126&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "443cb126",
  null
  
)

export default component.exports